// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-0b822c33]{padding:6px 18px;border-radius:3px;border:1px solid #b1cff2;background-color:#fff;color:#2680eb;margin-top:3px;font-size:14px;font-weight:400;text-align:center}.button .menu-icon[data-v-0b822c33]{height:10px;margin-right:4px}.button[data-v-0b822c33]:last-of-type{border-radius:3px 3px 18px 18px;margin-bottom:2px}.failed .button[data-v-0b822c33]{border:1px solid #ff5b61;color:#ff5b61}", ""]);
// Exports
module.exports = exports;
